import * as React from "react";



interface State {
    title? : string;
    collapsed? : boolean;
}
interface Props {title: string, collapsed: boolean}
export class Collapsible extends React.Component<Props,State>{

    constructor(props  : Props) {
        super(props);
        console.log("Props: ", props);
        this.state = { collapsed : this.props.collapsed};
    }

    toggleCollapsed() {
        console.log("Before toogle - Collapsed: "+this.state.collapsed);
        this.setState({collapsed : !this.state.collapsed});
        console.log("After toogle - Collapsed: "+this.state.collapsed);
    }

    getContent() {
        if (this.state.collapsed) {
            return <div></div>
        } else {
            return (
                <div className="ibox-content">
                    {this.props.children}
                </div>
            )
        }
    }

    getIcon() {
        if (this.state.collapsed) {
            return "right"
        } else {
            return "down"
        }
    }

    render() {
        return (
            <div className="card-box">
                <h4 className="pointer" onClick={this.toggleCollapsed.bind(this)}><i className={"fa fa-chevron-"+this.getIcon()}></i> {this.props.title}</h4>
                { this.getContent() }
            </div>
        )
    }
}
